<template>
    
    <!--Content-->
    <div class="flex flex--content surface-100">
        <div class="w-full border-noround">
            <!--Content start -->
            <router-view />
            <!--Content end -->
        </div>
    </div>
    
</template>

<script>
/* eslint-disable */
// import { useRoute } from 'vue-router'

export default {
    name: 'App',
    data() {
        return {
            
        }
    },
    components: {
        
    },
    watch: {
        
    },
    computed: {
        
    },
    methods: {
        
    },

    async beforeCreate() {
        
    },
    created() {
        
    },
    destroyed() {
        
    },
    async mounted() {
        
    },
}
</script>